<div class="manager-loader-wrapper-global">
  <div class="spinner-border w-55px h-55px"></div>
</div>
